/**
 * extraLazy
 * -----------------
 * Super simple, extra lazy, dynamic Component loading. The referenced
 * module should export the Component as default.
 *
 * Usage:
 *
 * const LazyLoadedImageComponent = extraLazy(
 *     () => import('path/to/ImageComponent')
 * );
 * ```
 *
 * For more options/info regarding dynamic imports, see:
 * https://webpack.js.org/guides/code-splitting/#dynamic-imports
 *
 * @param loader A function that returns a Promise that resolves into a Component module.
 */
import { __assign, __extends } from "tslib";
import * as React from 'react';
import { debug } from 'shared/utils';
var extraLazy = function (loader) {
    var ExtraLazy = /** @class */ (function (_super) {
        __extends(ExtraLazy, _super);
        function ExtraLazy() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                loadedComponent: undefined,
            };
            return _this;
        }
        ExtraLazy.prototype.componentDidMount = function () {
            var _this = this;
            loader()
                .then(function (loadedModule) {
                var loadedComponent = 'default' in loadedModule
                    ? loadedModule.default
                    : loadedModule;
                _this.setState({ loadedComponent: loadedComponent });
            })
                .catch(function (e) {
                debug('Error loading module', e);
            });
        };
        ExtraLazy.prototype.render = function () {
            var LoadedComponent = this.state.loadedComponent;
            if (!LoadedComponent) {
                return null;
            }
            return React.createElement(LoadedComponent, __assign({}, this.props));
        };
        return ExtraLazy;
    }(React.Component));
    return ExtraLazy;
};
export default extraLazy;
